import { CONST } from "../../CONST";
import Distraction from "./Distraction";

const config = {
    difficulty: {
       spawnTime: {start: {min: 2000, max: 3000},
                    end: {min: 500, max: 1500},
                }
    },
    score: {
        max: 100,
    }
}

export default class DistractionManager {
    public difficultyConfig = {//CONTROLLED BY REMOTECONFIG SCENE!
        timeToReachEnd: 30000,

        defaultScoreSpeed: -25,
        activeDistractionSpeedChange: 15,
        startSpawnTimeMultiplier: 1,
        endSpawnTimeMultipler: 1,
    }

    private scene : Phaser.Scene;

    private distractions : Distraction[] = [];

    private spawner : DistractionSpawner;
    private score : DistractionScore;
    private survivalTimer: SurvivalTime;

    private static activeCount = 0; //how many distractions are currently active

    private lastActiveCount = 0;

    constructor(distractions: Distraction[], startTime: number, scene: Phaser.Scene){
        this.scene = scene;

        this.getRemoteConfig();

        this.distractions = distractions;

        this.spawner = new DistractionSpawner(this);
        this.score = new DistractionScore();
        this.survivalTimer = new SurvivalTime(startTime);

        this.distractions.forEach(dist => {
            dist.setCallbacks(this.onDistractionActivated, this.onDistractionDeactivated)
        });

        DistractionManager.activeCount = 0;
    }

    private getRemoteConfig(){
            let remoteConf = this.scene.remoteConf.getConfig("gD").split(";");

            this.difficultyConfig.timeToReachEnd = parseInt(remoteConf[0]) * 1000;
            this.difficultyConfig.defaultScoreSpeed = parseInt(remoteConf[1]) * -1;
            this.difficultyConfig.activeDistractionSpeedChange = parseInt(remoteConf[2]);
            this.difficultyConfig.startSpawnTimeMultiplier = parseInt(remoteConf[3]) / 100;
            this.difficultyConfig.endSpawnTimeMultipler = parseInt(remoteConf[4]) / 100;

            // console.log("difficulty");
            // console.log(this.difficultyConfig);
    }

    public _update(time: number, delta: number){
        this.spawner._update(time, delta);

        if (this.getActiveCount() != this.lastActiveCount){
            this.lastActiveCount = this.getActiveCount();
            this.score.updateScoreChangeSpeed(this.getActiveCount(), this);
        }

        this.score.updateScore(delta);
        this.survivalTimer.updateTime(delta);
    }

    public onDistractionActivated(){
        DistractionManager.activeCount ++;
        // console.log("Active count: " + DistractionManager.activeCount + " (activated)");
    }

    public onDistractionDeactivated(){
        DistractionManager.activeCount --;
        // console.log("Active count: " + DistractionManager.activeCount + " (deactivated)");
    }

    public startSpawning(){
        this.survivalTimer.startTiming();
        this.spawner.startSpawning();
    }

    public onGameLost(){
        //disable interactive in all distractions
        this.distractions.forEach(dist => dist.onGameLost());
        this.survivalTimer.stopTiming();
    }

    private getActiveCount(){
        return DistractionManager.activeCount;
    }

    public getDistractions(){
        return this.distractions;
    }

    public getScore(){
        return this.score.getCurrentScore();
    }

    public getSurvivalTimeInSeconds(){
        return Math.round(this.getSurvivalTime()/1000);
    }

    public getSurvivalTime(){
        return this.survivalTimer.getTime();
    }

}

class DistractionScore {
    private currentScore: number = 0;
    private scoreChangeSpeed: number = 0;

    updateScoreChangeSpeed(activeDistractions: number, dManager: DistractionManager){
        this.scoreChangeSpeed = dManager.difficultyConfig.defaultScoreSpeed + activeDistractions * dManager.difficultyConfig.activeDistractionSpeedChange;
    } 

    updateScore(delta: number){
        this.currentScore += this.scoreChangeSpeed * delta / 1000;
        this.currentScore = Math.min(Math.max(this.currentScore, 0), config.score.max);
    }

    getCurrentScore(){
        return this.currentScore;
    }
}

class SurvivalTime {
    private time = 0;
    private isAlive = false;

    constructor(startTime: number){
        this.time = startTime;
    }

    updateTime(delta: number){
        if (!this.isAlive) return;
        this.time += delta;
    }

    startTiming(){
        this.isAlive = true;
    }

    stopTiming(){
        this.isAlive = false;
    }

    getTime(){
        return this.time;
    }
}

class DistractionSpawner {
    private dManager: DistractionManager;

    private nextSpawnTimer = 0;
    private isSpawning = false;

    constructor(distractionManager: DistractionManager){
        this.dManager = distractionManager;
    }

    public startSpawning(){
        this.isSpawning = true;
        this.calculateNextSpawnTime();
    }

    public _update(time: number, delta: number){
        if (!this.isSpawning) return;

        this.nextSpawnTimer -= delta;
        if (this.nextSpawnTimer < 0){
            this.spawnRandomDistraction();
            this.calculateNextSpawnTime();
        }
    }

    //Activates 
    private spawnRandomDistraction(){
        let availableDistractions : Distraction[] = [];
        this.dManager.getDistractions().forEach(dist => {
            if (!dist.isPendingActivation()){
                availableDistractions.push(dist);
            }
        });

        if (availableDistractions.length == 0){
            // console.log("Can't activate any distractions!!!");
            return;
        }

        let nextDistraction = Phaser.Utils.Array.GetRandom(availableDistractions);
        nextDistraction.activate();
    }

    private calculateNextSpawnTime(){
        let spawnDiff = config.difficulty.spawnTime;

        let progress = Math.min(this.dManager.getSurvivalTime() / this.dManager.difficultyConfig.timeToReachEnd, 1);
        let min = Phaser.Math.Linear(spawnDiff.start.min * this.dManager.difficultyConfig.startSpawnTimeMultiplier, spawnDiff.end.min * this.dManager.difficultyConfig.endSpawnTimeMultipler, progress);
        let max = Phaser.Math.Linear(spawnDiff.start.max * this.dManager.difficultyConfig.startSpawnTimeMultiplier, spawnDiff.end.max * this.dManager.difficultyConfig.endSpawnTimeMultipler, progress);


        this.nextSpawnTimer = this.getRandomInt(min, max);
    }

    private getRandomInt(min: number, max: number) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}